"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _isNil = _interopRequireDefault(require("lodash/isNil"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _AutoSizer = _interopRequireDefault(require("react-virtualized/dist/commonjs/AutoSizer"));

var _ScrollSync = _interopRequireDefault(require("react-virtualized/dist/commonjs/ScrollSync"));

var SizedScrollSync =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2.default)(SizedScrollSync, _PureComponent);

  function SizedScrollSync() {
    (0, _classCallCheck2.default)(this, SizedScrollSync);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(SizedScrollSync).apply(this, arguments));
  }

  (0, _createClass2.default)(SizedScrollSync, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          defaultHeight = _this$props.defaultHeight,
          defaultWidth = _this$props.defaultWidth,
          manualHeight = _this$props.height,
          nonce = _this$props.nonce,
          style = _this$props.style,
          manualWidth = _this$props.width,
          onResize = _this$props.onResize;
      return _react.default.createElement(_AutoSizer.default, {
        className: className,
        defaultHeight: (0, _isNil.default)(defaultHeight) ? manualHeight : defaultHeight,
        disableHeight: !(0, _isNil.default)(manualHeight),
        defaultWidth: (0, _isNil.default)(defaultWidth) ? manualWidth : defaultWidth,
        disableWidth: !(0, _isNil.default)(manualWidth),
        nonce: nonce,
        style: style,
        onResize: onResize
      }, function (_ref) {
        var height = _ref.height,
            width = _ref.width;
        return _react.default.createElement(_ScrollSync.default, null, function (scrollSync) {
          return children(manualWidth || width, manualHeight || height, scrollSync);
        });
      });
    }
  }]);
  return SizedScrollSync;
}(_react.PureComponent);

exports.default = SizedScrollSync;
(0, _defineProperty2.default)(SizedScrollSync, "propTypes", {
  children: _propTypes.default.func.isRequired,
  className: _propTypes.default.string,
  defaultHeight: _propTypes.default.number,
  defaultWidth: _propTypes.default.number,
  height: _propTypes.default.number,
  nonce: _propTypes.default.string,
  style: _propTypes.default.objectOf(_propTypes.default.any),
  width: _propTypes.default.number,
  onResize: _propTypes.default.func
});